import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit {
  loginForm: FormGroup;
  formSubmitAttempt = false;
  loading: boolean;
  returnUrl;
  error: any;
  success: any;
  otp: boolean;
  link;
  otperror: any;
  type;
  recoveryCode: boolean = false;
  source;
  private eventSubscription: Subscription;
  constructor(
    private userSvc: UserService,
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      captcha: [''],
      otp: [''],
      recoveryCode: [''],
    });
    this.eventSubscription = this.userSvc.getEvent().subscribe((event) => {
      if (event) {
        this.otp = false;
        this.loginForm.reset();
      }
    });
    this.route.queryParams.subscribe((params) => {
      const token = params['token'];
      let url = params['return_url'];
      this.source = params['source'];
      // console.log('url ', url);
      if (url) {
        this.returnUrl = url;
        this.link = url;
      }
      console.log(this.source, 'source');
      // }
    });
  }
  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
  }
  switchRecovery() {
    this.recoveryCode = true;
    this.otperror = null;
    this.formSubmitAttempt = false;
    this.loginForm.patchValue({
      otp: '',
    });
  }

  ngOnInit(): void {}

  isFieldValid(field: string) {
    return (
      (!this.loginForm.get(field).valid && this.loginForm.get(field).touched) ||
      (this.loginForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  login() {
    this.formSubmitAttempt = false;
    if (this.loginForm.value.username && this.loginForm.value.password) {
      this.error = null;
      let newUrl;
      this.loading = true;
      this.loginForm.value.returnUrl = this.returnUrl;
      const credentials = {
        username: this.loginForm.value.username,
        password: this.loginForm.value.password,
      };
      const credentialsString = JSON.stringify(credentials);
      const loginObject = JSON.parse(
        window.localStorage.getItem('loginObject')
      );
      let payload = {
        captcha: this.loginForm.value.captcha,
        data: btoa(unescape(encodeURIComponent(credentialsString))),
        returnUrl: this.loginForm.value.returnUrl,
        otp: this.loginForm.value.otp,
        recoveryCode: this.loginForm.value.recoveryCode,
      };
      if (
        loginObject &&
        loginObject?.length > 0 &&
        this.source === 'procurement'
      ) {
        payload['source'] = 'procurement';
        payload['sourceData'] = `lotIds=${loginObject
          .map((item) => `${item.lotId},${item.biddingStageId}`)
          .join(';')}`;
      }
      this.userSvc.auth({ body: payload }).subscribe(
        (res) => {
          this.returnUrl = res['returnUrl'];
          this.loading = false;
          if (this.loginForm.value.recoveryCode) {
            window.localStorage.setItem('recoveryCodes', 'true');
          }
          if (this.link) {
            window.location.replace(this.returnUrl);
          } else {
            if (this.returnUrl.split('#')[1]) {
              this.router.navigateByUrl(this.returnUrl.split('#')[1]);
            } else {
              window.location.replace(this.returnUrl);
            }
          }
        },
        (error) => {
          this.loading = false;
          if (error && error.error) {
            switch (error.error['status']) {
              case 400:
                this.error = error.error['userMessage'];
                break;
              case 404:
                this.error = 'Invalid login credentials, please try again';
                break;
              case 407:
                this.loginForm.get('otp').setValidators([Validators.required]);
                this.loginForm.updateValueAndValidity();

                if (error.error['errorCode'] === 240401) {
                  this.otp = true;
                  this.otperror = error.error['userMessage'];
                }
                if (error.error['errorCode'] === 240402) {
                  this.otp = false;
                  this.error = error.error['userMessage'];
                }
                if (error.error['errorCode'] === 240404) {
                  this.otp = true;
                  this.recoveryCode = true;
                  this.error = error.error['userMessage'];
                }
                if (error.error['errorCode'] === 240403) {
                  this.otp = true;
                  this.type = 'Enter the OTP sent to your e-mail.';
                }
                if (error.error['errorCode'] === 240400) {
                  this.otp = true;
                  this.type = 'Enter the OTP from Authenticator App.';
                }
            }
            if (error.error['statusCode'] == 500) {
              this.error = 'Invalid login credentials, please try again';
            }
            // if (error.error['statusCode'] == null || undefined) {
            //   this.error = error.error;
            // }
          }
        }
      );
    } else {
      this.formSubmitAttempt = true;
    }
  }
}
